export const AUTH_HEADER_PREFIX = '42-'

export const AUTH_HEADERS = {
  apiKey: '42-api-key',
  signature: '42-signature',
  timestamp: '42-timestamp',
}
